import {EventEmitter, Injectable, signal} from "@angular/core";
declare let gtag: Function;

@Injectable({providedIn: 'root'})
export class Ga4Service {

    trackEvent(event: any, params: any) {

    }


}